import { normalizeTranslatableText, translationSourceHash } from "./spanish";

/** Short picker strings that sit next to catalog names on a translated form. */
export const CATALOG_PICKER_SOURCES = {
  searchBusinessType: "Search business type...",
  emptyBusinessType: "No business type found.",
  loadingBusinessTypes: "Loading business types...",
  businessTypeLoadError: "Couldn't load business types.",
  searchIndustries: "Search kinds of businesses...",
  emptyIndustries: "No matching businesses found.",
  useText: "Use “{Text}”",
} as const;

export function catalogPickerSources(): string[] {
  return Object.values(CATALOG_PICKER_SOURCES);
}

export function translatedCatalogLabel(
  english: string,
  translations?: Record<string, string> | null,
): string {
  if (!translations) return english;
  const text = translations[translationSourceHash(english)]?.trim();
  return text || english;
}

export function catalogSearchText(
  parts: Array<string | null | undefined>,
  translations?: Record<string, string> | null,
): string {
  const values: string[] = [];
  for (const part of parts) {
    const text = part?.trim();
    if (!text) continue;
    values.push(text);
    const translated = translatedCatalogLabel(text, translations);
    if (translated !== text) values.push(translated);
  }
  return values.join(" ");
}

export function catalogUseLabel(
  typed: string,
  translations?: Record<string, string> | null,
): string {
  const template = translatedCatalogLabel(
    CATALOG_PICKER_SOURCES.useText,
    translations,
  );
  if (!template.includes("{Text}")) return `Use “${typed}”`;
  return template.replaceAll("{Text}", typed);
}

/** Names that still need a translation. Blank and repeated names are skipped. */
export function catalogNamesMissingTranslation(
  names: readonly string[],
  translatedHashes: ReadonlySet<string>,
): string[] {
  const missing: string[] = [];
  const seen = new Set<string>();
  for (const name of names) {
    const text = normalizeTranslatableText(name);
    if (!text || seen.has(text)) continue;
    seen.add(text);
    if (!translatedHashes.has(translationSourceHash(text))) missing.push(text);
  }
  return missing;
}
